export const REMOVE_ITEM_LEXICON = `Удалить`;
export const SECTION_HEADING = `Список`;
